import { CreditCard } from '@/types/quiz';
import { CheckCircle, ExternalLink } from 'lucide-react';

interface ResultCardProps {
  card: CreditCard;
  isPrimary?: boolean;
  onClick?: () => void;
}

export const ResultCard = ({ card, isPrimary = false, onClick }: ResultCardProps) => {
  return (
    <div className={`border-2 rounded-2xl p-4 md:p-6 transition-all duration-200 ${
      isPrimary 
        ? "border-primary bg-gradient-to-br from-primary/5 to-primary/10 shadow-button" 
        : "border-border bg-card"
    }`}>
      {isPrimary && (
        <div className="flex items-center gap-2 mb-3 md:mb-4 bg-primary/10 border border-primary/20 rounded-lg px-3 py-1.5 md:py-2 w-fit">
          <CheckCircle className="w-4 h-4 md:w-5 md:h-5 text-primary" />
          <span className="text-xs md:text-sm font-semibold text-primary">Beste valg for deg</span>
        </div>
      )}
      
      <div className="mb-3 md:mb-4">
        <img 
          src={card.imageUrl} 
          alt={card.name} 
          className="w-full h-16 md:h-24 object-contain rounded-lg bg-gradient-to-br from-muted/30 to-muted/10 p-2"
        />
      </div>
      
      <h3 className="text-lg md:text-xl font-bold text-foreground mb-1 md:mb-2">{card.name}</h3>
      <p className="text-sm md:text-base text-muted-foreground mb-3 md:mb-4">{card.description}</p>
      
      <ul className="space-y-1.5 md:space-y-2 mb-4 md:mb-6">
        {card.benefits.map((benefit, index) => (
          <li key={index} className="flex items-start gap-2 text-xs md:text-sm">
            <CheckCircle className="w-3.5 h-3.5 md:w-4 md:h-4 text-primary mt-0.5 flex-shrink-0" />
            <span>{benefit}</span>
          </li>
        ))}
      </ul>
      
      <div className="mb-3 md:mb-4 p-2 md:p-3 bg-muted/30 rounded-lg border border-border">
        <p className="text-[10px] md:text-xs text-muted-foreground leading-tight">{card.interestExample}</p>
      </div>
      
      <a 
        href="https://www.lendo.no/kredittkort/soknad/" 
        target="_blank" 
        rel="noopener noreferrer"
        onClick={onClick}
        className={`w-full py-2.5 md:py-3 px-4 rounded-xl text-sm md:text-base font-medium transition-all duration-200 flex items-center justify-center gap-2 ${
          isPrimary
            ? "bg-gradient-primary text-primary-foreground hover:scale-[1.02] shadow-button"
            : "bg-secondary text-secondary-foreground hover:bg-secondary/80"
        }`}
      >
        Søk kredittkort
        <ExternalLink className="w-3.5 h-3.5 md:w-4 md:h-4" />
      </a>
    </div>
  );
};